import { render } from "./ScreenPathsToStay.vue?vue&type=template&id=672b153a"
import script from "./ScreenPathsToStay.vue?vue&type=script&lang=js"
export * from "./ScreenPathsToStay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__